import ApiService from '../../../services/apiService';
import URL from '../../../urls/Urls';
import { API_CONFIG, USE_MOCK } from './constants';
import type { VendorsApiResponse } from './types';

/**
 * apiFetch
 * Calls an internal REST endpoint with Bearer token auth.
 * Returns MOCK_VENDORS when USE_MOCK = true.
 */

/**
 * callClaude
 * Sends a prompt to Claude and returns the parsed JSON response.
 * Generic parameter T lets each call site type the expected shape.
 */
export async function callClaude<T = unknown>(
  prompt: string,
  max_tokens = 1800
): Promise<T> {
  const { data } = await ApiService().client.post(URL.CLAUDE.CALL, {
    max_tokens,
    prompt,
  });
  return data;
}
